module.exports = __webpack_public_path__ + "static/media/brockLogo.a7bcf77e.svg";